<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p style="text-align: center;"><span dir="rtl">هناك بعيدًا فضاء مكبَّل بالسعادة، فيه بوَّابة بيت عتيق، تسكن بين ياسمينتَين زرعَتهما أمِّي، وأتقنتا فنَّ جمْع الذِّكريات، أراكَ فيه جالسًا فوق كرسِيَّك الأزليّ، تترقَّب عودتي.</span></p>
<p style="text-align: center;"><span dir="rtl">إلى روح أبي</span>.</p>
<p><strong><span dir="rtl"><br/>
</span></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?16bfe849